module.exports = __webpack_public_path__ + "img/img-otp.6be57cc0.svg";